import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import * as bankLogo from "./ribbon-bank.svg";
import * as carLogo from "./ribbon-car.svg";
import * as fastLogo from "./ribbon-fast.svg";
import "./Ribbon.scss";

const Ribbon = ({ t }: WithTranslation) => (
    <div className="Ribbon">
        <div className="Ribbon__box Ribbon__box--left">
            <div className="Ribbon__box-circle">
                <img className="Ribbon__box-icon" src={bankLogo} alt="bank" />
            </div>
            <p className="Ribbon__box-label">{t("UserAccount.CreateGarage.Ribbon.left")}</p>
        </div>
        <div className="Ribbon__box Ribbon__box--center">
            <div className="Ribbon__box-circle">
                <img className="Ribbon__box-icon" src={carLogo} alt="car" />
            </div>
            <p className="Ribbon__box-label">{t("UserAccount.CreateGarage.Ribbon.center")}</p>
        </div>
        <div className="Ribbon__box Ribbon__box--right">
            <div className="Ribbon__box-circle">
                <img className="Ribbon__box-icon" src={fastLogo} alt="lightning" />
            </div>
            <p className="Ribbon__box-label">{t("UserAccount.CreateGarage.Ribbon.right")}</p>
        </div>
    </div>
);

export default withTranslation()(Ribbon);
